@if( getActiveTab() == TAB_PENDINGREJECTED ) {
    <tv-commercial-grid-component #tabPending [description]="'Pending/Rejected'" [filter]="pendingRejectedFilter" [refreshOnInit]="true"></tv-commercial-grid-component>
}
@if( getActiveTab() == TAB_HISTORY ) {
    <tv-commercial-grid-component #tabHistory [description]="'History'" [allowFiltering]="true" [showUploadedDate]="true" [filter]="latestFilter" [refreshOnInit]="true"></tv-commercial-grid-component>
}
